import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import PageHeader from "../../../components/Inspections/PageHeader";
import InspectionMasterFilters from "./InspectionMasterFilters";
import { getFilterState, saveFilterState } from "../../../utils";
import DataTable from "../../../components/DataTable";
import { INSPECTION_MASTER_COLUMNS, INSPECTION_CODES_COLUMNS } from "./columns";
import { ALL_INSPECTION_MASTER_QUERY } from "../../../graphql/InspectionMaster/InspectionMaster.graphql";
import { ModalContext } from "../../../components/ModalProvider";
import AddInspectionMasterForm from "../../../components/Inspections/AddInspectionMasterForm";
import EditInspectionMasterForm from "../../../components/Inspections/EditInspectionMasterForm";

import { useAuthorization } from "../../../components/Authorization";
import "./Inspections.scss";

function InspectionCodesPage() {
  const history = useHistory();
  const INITIAL_FILTER_STATE = getFilterState("INSPECTION_MASTER_FILTERS", {
    Active: true
  });
  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const { setModalOpen } = useContext(ModalContext);

  const handleSetFilters = inputs => {
    saveFilterState("INSPECTION_MASTER_FILTERS", inputs);
    setFilters({ ...inputs });
  };

  const MechanicAuth = useAuthorization(["MECH"]);
  const AdminAuth = useAuthorization(["ADMIN"]);

  const handleEditRow = row => {
    setModalOpen(
      true,
      <EditInspectionMasterForm
        inspectionMaster={row}
        onComplete={() => setModalOpen(false, "")}
      />
    );
  };

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={InspectionMasterFilters}
        actionsType="codes"
        columns={INSPECTION_CODES_COLUMNS}
        filters={filters}
        name="InspectionMasters"
        query={ALL_INSPECTION_MASTER_QUERY}
        readOnly={MechanicAuth && !AdminAuth}
        setFilters={handleSetFilters}
        title="Inspection Master"
        onAddClick={() =>
          setModalOpen(
            true,
            <AddInspectionMasterForm
              onComplete={() => setModalOpen(false, "")}
            />
          )
        }
      />
      <DataTable
        columns={INSPECTION_MASTER_COLUMNS(handleEditRow)}
        dataQuery={ALL_INSPECTION_MASTER_QUERY}
        initialSortBy={[
          {
            id: "InspectionCode",
            desc: false
          }
        ]}
        name="InspectionMaster"
        where={filters}
        onRowClick={data =>
          history.push(`/fleet/inspection-masters/inspections/${data.RecId}`)
        }
      />
    </React.Fragment>
  );
}
InspectionCodesPage.propTypes = {};
export default InspectionCodesPage;
